// React, Router and Services
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import productsService from "services/product-service";

// MUI and Material Dashboard components 
import CloseIcon from '@mui/icons-material/Close';
import VisibilityTwoToneIcon from "@mui/icons-material/VisibilityTwoTone";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// E4A React components
import DataTable from "e4acomponents/Tables/DataTable";

// Helper functions
import { convertDate } from "../helperFunctions";

export default function ViewDispatchesProducts({
    open,
    handleClose,
    dispatch,
}) {
    const [products, setProducts] = useState([]);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();

    // Fetch products when dialog opens
    useEffect(() => {
        if (open && Array.isArray(dispatch.productIds) && dispatch.productIds.length > 0) {
            (async () => {
                try {
                    const response = await productsService.getDispatchProducts(dispatch.id);
                    setProducts(response.data);
                    setTableData(getRows(response.data.attributes));
                } catch (error) {
                    console.error("Error fetching products:", error);
                }
            })();
        }
    }, [open])

    // Update table data when the products changes
    useEffect(() => {
        if (products.length > 0) {
            setTableData(getRows(products))
        }
    }, [products])

    // Transforms product data into table rows
    const getRows = (info) => {
        let updatedInfo = info
            .map((e) => {
                return {
                    id: e._id,
                    serialNumber: e.serialNumber,
                    firmwareVersion: e.firmwareVersion,
                    dateOfStorage: convertDate(e.dateOfStorage),
                    shelfLife: `${e.shelfLife[0]} ${e.shelfLife[1]}`,
                }
            })
        return updatedInfo;
    }

    // Data table structure
    const dataTableData = {
        columns: [
            { Header: "Serial Number", accessor: "serialNumber" },
            { Header: "Firmware Version", accessor: "firmwareVersion" },
            { Header: "Date of Storage", accessor: "dateOfStorage" },
            { Header: "Shelf Life", accessor: "shelfLife" },
            {
                Header: "Actions",
                accessor: "actions",
                disableSortBy: true,
                Cell: ({ row }) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View Product">
                                <IconButton
                                    onClick={() =>
                                        navigate(`/fulfillment-center/view-product/${row.original.id}`)
                                    }
                                >
                                    <VisibilityTwoToneIcon color="info" />
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    )
                }
            }
        ],
        rows: tableData,
    }
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl">
            
            {/* Dialog Header */}
            <DialogTitle>
                <MDBox display="flex" justifyContent="space-between">

                    {/* Title */}
                    <MDBox>
                        Dispatch #{dispatch?.dispatch_num} Products
                        <MDTypography variant="body2" color="text">
                            {dispatch?.description}
                        </MDTypography>
                    </MDBox>
                    
                    {/* Close Button */}
                    <MDBox>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </MDBox>
                
                </MDBox>
            </DialogTitle>

            {/* Dialog Content */}
            <DialogContent>
                
                {/* Dialog sub-title */}
                <DialogContentText>
                    Products associated with this dispatch request:
                </DialogContentText>
                
                {/* Data Table */}
                {tableData.length > 0 ? (
                    <DataTable
                        table={dataTableData}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                        tableId="dispatch-products-table"
                    />
                ) : ( // Message when no products are assigned
                    <MDBox
                        mt={2}
                        width="80vh"
                        height="40vh"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                    >
                        No products assigned yet
                    </MDBox>
                )}
                
            </DialogContent>
        </Dialog>
    )
}